module.exports = __webpack_public_path__ + "img/next1.b9990e2a.jpg";